module.exports = __webpack_public_path__ + "static/bg2-08203ce680ddb42303dd16079f26ea7b.jpg";